import { ProtectedView } from "@/app/protected-view";
import { Annotation } from "@/pages/annotation";
import { Assignment } from "@/pages/assignment";
import { GondolaChangeGroups } from "@/pages/gondola-change-groups";
import { Dashboard } from "@/pages/dashboard";
import { Login } from "@/pages/login";
import { DashboardOrderDetails } from "@/pages/dashboard-order-details";
import { Stores } from "@/pages/stores";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { DashboardLayout } from "@/pages/dashboard/ui/dashboard-layout";
import { Redirect } from "./redirect";
import SSCCVisualizer from "@/pages/sscc-visualizer";

export const appRouter = () =>
  createBrowserRouter(
    [
      {
        path: "/",
        element: <ProtectedView />,
        children: [
          { path: "/", element: <Navigate to="/stores" replace /> },
          { path: "/stores", element: <Stores /> },
          {
            path: "/stores/:storeKey",
            children: [
              { path: "assignment", element: <Assignment /> },
              {
                path: "dashboard",
                element: <DashboardLayout />,
                children: [
                  {
                    index: true,
                    element: <Dashboard />,
                  },
                  {
                    path: "f1-scores",
                    element: <Redirect to="dashboard" />,
                  },
                  {
                    path: "orders",
                    children: [
                      {
                        index: true,
                        element: <Redirect to="dashboard" />,
                      },
                      {
                        path: ":orderId",
                        element: <DashboardOrderDetails />,
                      },
                    ],
                  },
                ],
              },
              {
                path: "gondola-change-groups/:orderId?",
                element: <GondolaChangeGroups />,
              },
              {
                path: "sscc",
                element: <SSCCVisualizer />,
              },
              { path: ":orderId?", element: <Annotation /> },
            ],
          },
        ],
      },
      { path: "/login", element: <Login /> },
    ],
    {
      future: {
        v7_partialHydration: false,
        v7_fetcherPersist: false,
        v7_relativeSplatPath: false,
        v7_normalizeFormMethod: false,
        v7_skipActionErrorRevalidation: false,
      },
    }
  );
